export default __webpack_public_path__ + "static/stubai.uebersicht-454facca862b5c5d5797fc0da53772db.jpg";